import { render, staticRenderFns } from "./Anzeige.vue?vue&type=template&id=6918ff67&"
import script from "./Anzeige.vue?vue&type=script&lang=js&"
export * from "./Anzeige.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports